import React, { FC } from 'react';
import { Flex, RadioProps } from '@chakra-ui/react';
import {
  checkedDesktopStyle,
  checkoutMobileStyle,
  desktopStyle,
  mobileStyle,
} from '../../../common/constants/paymentStyles';
import { useScreenSizeState } from '@olo-web/client-state';

type T = RadioProps;

export const PaymentMethodRadioCard: FC<T> = (props) => {
  const { isMdDown } = useScreenSizeState();
  const focusRingStyle = {
    outline: '3px solid',
    outlineColor: 'black',
    outlineOffset: '2px',
  };
  const inputFocusVisibleSelector = {
    '&:has(input.chakra-radio__input:focus-visible)': focusRingStyle,
  };

  return (
    <Flex
      className="payment-item"
      border="2px solid rgba(0, 0, 0, 0.6)"
      pl={5}
      pr={5}
      sx={
        isMdDown
          ? { ...mobileStyle, ...inputFocusVisibleSelector }
          : { ...desktopStyle, ...inputFocusVisibleSelector }
      }
      cursor="pointer"
      height={isMdDown ? '56px' : '44px'}
      flex="auto"
      align="center"
      textStyle="pBold"
      _focus={{
        boxShadow: 'outline',
      }}
      _checked={isMdDown ? { ...checkoutMobileStyle } : { ...checkedDesktopStyle }}
      borderTopRadius={props.borderTopRadius}
      borderBottomRadius={props.borderBottomRadius}
      data-testid="payment-method"
      aria-hidden={false}
    >
      {props.children}
    </Flex>
  );
};
